import React from "react";
import {useState} from "react";
import Header from "./Header";
import HowToUse from "./HowToUse";
import AddForm from "./AddForm";



function Body(){
    const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    let date = Date();
    date = date.slice(0,15);

    const [howToUse, setHowToUse] = useState(false);
    const [disableForm, setDisableForm] = useState(false);
    const [toggleAdd, setToggleAdd] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalMessagePopup, setModalMessagePopup] = useState(false);

    const [data, setData] = useState(
        {
            total_hours : 0,
            total_time : {
                productive: {
                    hour: 0,
                    min: 0,
                },
                unproductive: {
                    hour: 0,
                    min: 0,
                }
            },
            productive: [],
            unproductive: [],
            key : 0
        }
    )

    function reset(){
        let temp = {
            total_hours : 0,
            total_time : {
                productive: {
                    hour: 0,
                    min: 0,
                },
                unproductive: {
                    hour: 0,
                    min: 0,
                }
            },
            productive: [],
            unproductive: [],
            key : 0
        }
        setDisableForm(false);
        setData(temp);
        displayMessage('Data reset');
    }

    function handleClick(e){
        e.preventDefault();
        
        if(document.getElementById('radio-y').checked){
            updateState(true)
            
        }
        if(document.getElementById('radio-n').checked){
            updateState(false)
        }
        document.getElementById('activity').value = "";
        document.getElementById('hours').value = 0;
        document.getElementById('minutes').value = 0;
        document.getElementById('radio-y').checked = false;
        document.getElementById('radio-n').checked = false;
        
    }

    function handleAdd(){
        setToggleAdd(!toggleAdd)
    }

    function updateState(bool){
        let temp = {...data};

        //Get input values
        let hours_node_value = Number(document.getElementById('hours').value);
        let minutes_node_value = Number(document.getElementById('minutes').value);

        if(hours_node_value === 0 && minutes_node_value === 0 ){
            return;
        }
            
        //if minutes > 60 minutes ------------------ THIS NEEDS TO BE A WHILE LOOP and come before the if.

        while(minutes_node_value > 60){
            hours_node_value++;
            minutes_node_value -= 60;
        }

        //if minutes = 60 minutes
        if(minutes_node_value === 60){
            hours_node_value++;
            minutes_node_value = 0;
        }


        //if Productive
        if(bool){
            //add object
            temp.productive.push({
                activity: document.getElementById('activity').value,
                time: {
                    hour: hours_node_value,
                    min: minutes_node_value,
                },
                id: temp.key
            })
            //increase the total time 
            temp.total_time.productive.hour += hours_node_value;
            temp.total_time.productive.min += minutes_node_value;

            //if total Productive Time minutes greater than 60
            if(temp.total_time.productive.min > 60){
                temp.total_time.productive.hour++;
                temp.total_time.productive.min -= 60;
            }
            
            //if total prodcutive time minutes = 60
            if(temp.total_time.productive.min === 60){
                temp.total_time.productive.hour++;
                temp.total_time.productive.min = 0;
            }


        }else if (!bool){
            temp.unproductive.push({
                activity: document.getElementById('activity').value,
                time: {
                    hour: hours_node_value,
                    min: minutes_node_value,
                },
                id: temp.key
            })


            /*This can be reused for both somehow. For now it works but . Look into it.*/

            //increase the total time 
            temp.total_time.unproductive.hour += hours_node_value;
            temp.total_time.unproductive.min += minutes_node_value;

            //if total Productive Time minutes greater than 60
            if(temp.total_time.unproductive.min > 60){
                temp.total_time.unproductive.hour++;
                temp.total_time.unproductive.min -= 60;
            }
            
            //if total prodcutive time minutes = 60
            if(temp.total_time.unproductive.min === 60){
                temp.total_time.unproductive.hour++;
                temp.total_time.unproductive.min = 0;
            }

            

        }

        temp.total_hours = temp.total_time.productive.hour + temp.total_time.unproductive.hour;

        if(temp.total_hours >= 24){
            setDisableForm(true);
        }

        //update key
        temp.key++;

        //Set the new data to state
        setData(temp);
        
        //Save the data to the browser local storage.
        saveData();
        printState();


    }

    function printState(){
        console.log(data);
    }

    const productiveList = data.productive.map((e) => {
        console.log(e.id);
        return <li>{e.activity}<br/>{e.time.hour} H - {e.time.min} M<button className="itemRemove" onClick={ () => {removeItem(e.id, "productive")}}>X</button></li>

    })

    const unproductiveList = data.unproductive.map((e) =>{
        return <li>{e.activity}<br/> {e.time.hour} H - {e.time.min} M<button className="itemRemove" onClick={ () => {removeItem(e.id, "unproductive")}}>X</button> </li>
    })

    function toggleHowToUse(){
        setHowToUse(!howToUse);
    }
    
    /*        {toggleAdd && <AddForm click={handleClick} disableForm={disableForm}/>}*/
    /*        <Header total_hours={data.total_hours} reset={reset} htu={toggleHowToUse} total_productive_hours = {data.total_time.productive.hour} handleAdd={handleAdd}/> */

    /*LOCAL STORAGE*/
    function saveData(){
        displayMessage('Data saved to Browser');
        localStorage.setItem('data', JSON.stringify(data));
    }

    function loadData(){
        if(localStorage.getItem('data')){
            displayMessage('Data loaded from Browser');
            setData(JSON.parse(localStorage.getItem('data')))
        }else{
        displayMessage('Error: no Browser data found.');
        }
        
    }

    function clearData(){
        displayMessage('Data Cleared from Browser');
        localStorage.clear();
    }

    function displayMessage(message){
        setModalMessagePopup(true);
        setModalMessage(message);
        setTimeout(() =>{
            resetModalMessage();
        },3000)
    }

    function resetModalMessage(){
        setModalMessagePopup(false);
        setModalMessage("");
    }

    function removeItem(id, type){
        let temp = {...data}
        let index = 0;
        if(type === "productive"){
            console.log(`Index:` + temp.productive.findIndex(e => e.id === id));
            index = temp.productive.findIndex(e => e.id === id)

            let hours = temp.productive[index].time.hour;
            let minutes = temp.productive[index].time.min;

            //update time
            temp.total_time.productive.hour -= hours;
            temp.total_time.productive.min -= minutes;

            temp.productive.splice(index, 1);
        }
        if(type === "unproductive"){
            console.log(`Index:` + temp.unproductive.findIndex(e => e.id === id));
            index = temp.unproductive.findIndex(e => e.id === id);

            let hours = temp.unproductive[index].time.hour;
            let minutes = temp.unproductive[index].time.min;

            //update time
            temp.total_time.unproductive.hour -= hours;
            temp.total_time.unproductive.min -= minutes;

            temp.unproductive.splice(index, 1);
        
        }

        //set total hours
        let total = temp.total_time.productive.hour + temp.total_time.unproductive.hour;
        temp.total_hours = total;
        setData(temp);

    }

    function printContent(){
        document.querySelector('.print').hidden = true;
        window.print();
    }

    return(
        <>
        <Header total_hours={data.total_hours} reset={reset} htu={toggleHowToUse} total_productive_hours = {data.total_time.productive.hour} handleAdd={handleAdd} handleSave={saveData} handleLoad={loadData} handleClear={clearData} print={printContent}/>


        {toggleAdd && <AddForm click={handleClick} disableForm={disableForm}/> }

        <div class="list-container">

        <div class="list-container_left">
        <h2>Productive: <br/>
        {data.total_time.productive.hour} H {data.total_time.productive.min} M</h2>
        <ul>
            {productiveList}
        </ul>
        </div>
        <div class="list-container_right">
        <h2>Unproductive: <br/> {data.total_time.unproductive.hour} H {data.total_time.unproductive.min} M</h2>
            {unproductiveList}
        </div>

        </div>

        
        {howToUse && <HowToUse click={toggleHowToUse}/>}

        {modalMessagePopup && <div class="popup-modal">

            <p class="popup-modal-message">{modalMessage}</p>

        </div>}

        <div class="print">
            <h2>Today's Date: {date}</h2>
            <h2>Total Hours {data.total_hours}</h2>
            <h2>Your day has been {(data.total_time.productive.hour / 24 * 100).toFixed(2)}% Productive</h2>
            <h3>Productive</h3>
            {productiveList}
            <h4>Unproductive</h4>
            {unproductiveList}
        </div>

        </>
    )
}


export default Body;